import { Button, MenuItem, styled, useTheme } from "@mui/material";
import { HoverMenu } from "./popup-state/hover-menu.js";
import { isExternalRoute, isInternalRoute, isParentRoute } from "./model.js";
import { match } from "ts-pattern";
import { usePopupState, bindHover, bindMenu } from "material-ui-popup-state/hooks";
import { useRouter } from "next/router";
import Link from "next/link";
import React from "react";
const StyledButton = styled(Button, {
    shouldForwardProp: (p) => !["isActive", "indicatorColor"].includes(p),
})(({ theme, isActive }) => ({
    textTransform: "none",
    ...theme.typography.body1,
    "&&&": {
        color: "inherit",
        letterSpacing: "0.025em",
        padding: `${theme.spacing(2)} ${theme.spacing(0.5)}`,
        transition: theme.transitions.create(["opacity"]),
    },
    "&:hover": {
        backgroundColor: "transparent",
        opacity: isActive ? 1 : 0.7,
        cursor: isActive ? "default" : "pointer",
    },
}));
export const NavItem = ({ indicatorColor, item }) => {
    const theme = useTheme();
    const router = useRouter();
    const popupState = usePopupState({
        variant: "popover",
        popupId: `${item.label}-submenu`,
    });
    const makeParentLinkProps = (an) => match(an)
        .when(isInternalRoute, ({ route }) => ({
        href: route,
        LinkComponent: Link,
    }))
        .when(isExternalRoute, ({ href }) => ({
        href,
    }))
        .when(isParentRoute, ({ children }) => {
        throw new Error("Nested parent routes are not allowed.");
    })
        .exhaustive();
    const interpretItem = (an) => match(an)
        .when(isInternalRoute, ({ label, route }) => {
        const path = router.asPath;
        const isActive = path === route || (path.startsWith(route) && route !== "/");
        const linkProps = isActive ? {} : { href: route, LinkComponent: Link };
        return (React.createElement(StyledButton, { indicatorColor: indicatorColor, isActive: isActive, variant: "text", ...linkProps }, label));
    })
        .when(isExternalRoute, ({ href, label }) => (React.createElement(StyledButton, { isActive: false, href: href, indicatorColor: indicatorColor, variant: "text" }, label)))
        .when(isParentRoute, ({ children, label }) => {
        return (React.createElement(React.Fragment, null,
            React.createElement(StyledButton, { indicatorColor: indicatorColor, isActive: false, variant: "text", ...bindHover(popupState), ...makeParentLinkProps(children[0]) }, label),
            React.createElement(HoverMenu, { ...bindMenu(popupState), anchorOrigin: { vertical: "bottom", horizontal: "center" }, anchorReference: "anchorEl", disableScrollLock: true, transformOrigin: { vertical: "top", horizontal: "center" }, PaperProps: {
                    elevation: 0,
                    sx: {
                        bgcolor: "white",
                        border: `1px solid ${theme.palette.divider}`,
                        borderRadius: "8px",
                        boxShadow: "0 50px 100px -20px rgba(50,50,93,0.25),0 30px 60px -30px rgba(0,0,0,0.3)",
                        overflow: "visible",
                        px: 1.5,
                        py: 1,
                        zIndex: 1,
                        "&:before": {
                            // arrow
                            backgroundColor: "white",
                            border: "1px solid",
                            borderColor: `${theme.palette.divider} transparent transparent ${theme.palette.divider}`,
                            bottom: "calc(100% - 8px)",
                            content: '""',
                            display: "block",
                            height: "16px",
                            left: 0,
                            margin: "auto",
                            position: "absolute",
                            right: 0,
                            transform: "rotate(45deg)",
                            verticalAlign: "middle",
                            width: "16px",
                        },
                    },
                } }, children.map((child) => match(child)
                .when(isInternalRoute, ({ label, route }) => (React.createElement(MenuItem, { key: `child-internal-${label}`, onClick: () => router.push(route ?? "/404"), sx: {
                    color: theme.palette.grey[800],
                    transition: theme.transitions.create(["color"]),
                    a: { textDecoration: "none" },
                    "&:hover": { backgroundColor: "white", color: theme.palette.text.primary },
                } }, label)))
                .when(isExternalRoute, ({ label, href }) => (React.createElement(MenuItem, { key: `child-external-${label}`, href: href, sx: {
                    color: theme.palette.grey[800],
                    transition: theme.transitions.create(["color"]),
                    a: { textDecoration: "none" },
                    "&:hover": { backgroundColor: "white", color: theme.palette.text.primary },
                } }, label)))
                .when(isParentRoute, () => {
                throw new Error("Nested parent routes are not allowed.");
            })
                .exhaustive()))));
    })
        .exhaustive();
    return interpretItem(item);
};
//# sourceMappingURL=desktop-item.js.map